<template>
  <header v-show="this.$store.state.currentUrlX.indexOf('/500') == -1">
    <nav class="navbar navbar-expand-lg navbar-light bg-on-primary">
      <div class="container">
        <router-link to="/" class="navbar-brand">
          <img :src="this.$store.state.systemLogoX" alt="" />
        </router-link>
        <div class="d-xl-none d-lg-none d-sm-flex d-flex align-items-center">
          <a
            href="javascript:;"
            class="d-flex justify-content-center mobile-search"
          >
            <div class="mobile-search-input-box">
              <input
                v-model="this.$store.state.searchInputValueX"
                v-on:change="searchEngine()"
                ref="mobileSearchInput"
                type="text"
                id="mobile-search"
                class="form-control"
              />
              <label for="mobile-search" class="material-icons-outlined"
                >search</label
              >
            </div>
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="material-icons-outlined"> menu </span>
          </button>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link
                class="nav-link"
                :to="'/' + this.$store.state.langCodeX"
                >{{
                  this.$store.getters.getWordLocale("txt_anasayfa")
                }}</router-link
              >
            </li>
            <li v-for="(item, index) in headerItemsToShow" :key="index">
              <router-link :to="item.link" class="nav-link">{{
                this.$store.getters.getWordLocale(item.name.toUpperCase())
              }}</router-link>
            </li>
          </ul>
          <ul
            v-show="
              this.$store.state.isMountedDoneX &&
              !this.$store.state.isLoginPageX
            "
            class="navbar-nav"
          >
            <li class="nav-item">
              <div class="search">
                <i class="fa fa-search"></i>
                <input
                  v-model="this.$store.state.searchInputValueX"
                  v-on:change="searchEngine()"
                  type="text"
                  class="form-control"
                  :placeholder="
                    this.$store.getters.getWordLocale(
                      'txt_firma_talep_urun_arayin'
                    )
                  "
                />
              </div>
            </li>

            <li
              v-if="!this.$store.state.userLoggedInX"
              class="nav-item d-flex flex-wrap justify-content-between"
            >
              <a
                class="
                  btn
                  text-light-primary
                  d-flex
                  align-center
                  header-login-btn
                "
                :href="
                  this.$store.state.loginUrlX +
                  '/' +
                  this.$store.state.langCodeX +
                  '?apilogin=true&returnUrl=' +
                  this.$store.state.currentUrlX +
                  '&referer=' +
                  hostUrl
                "
                ><i class="material-icons-outlined"> verified_user </i>
                {{ this.$store.getters.getWordLocale("txt_giris_yap") }}
              </a>
              <a
                class="btn btn-on-primary header-sign-up-btn"
                :href="this.$store.state.signUpUrlX +
                  '?referer=' +
                  hostUrl"
                target="_blank"
              >
                {{ this.$store.getters.getWordLocale("txt_uye_ol") }}</a
              >
            </li>

            <li v-else>
              <div class="dropdown">
                <button
                  class="btn btn-my-account dropdown-toggle"
                  type="button"
                  v-on:click="reversePanelArrow"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i class="material-icons-outlined">person</i>
                  {{
                    this.$store.state.userNameX.length > 20
                      ? `${this.$store.state.userNameX.substr(0, 20)}...`
                      : this.$store.state.userNameX
                  }}
                  <span v-if="!userPanelOpened" class="material-icons-outlined">
                    arrow_drop_down
                  </span>
                  <span v-else class="material-icons-outlined">
                    arrow_drop_up
                  </span>
                </button>
                <ul
                  class="dropdown-menu dropdown-menu-end my-account-dropdown"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <li>
                    <a
                      class="dropdown-item"
                      :href="this.$store.state.userDashboardUrlX"
                      ><i class="material-icons-outlined">person</i>
                      <span>{{
                        this.$store.getters.getWordLocale("txt_benim_sayfam")
                      }}</span></a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      :href="this.$store.state.companyManagementUrlX"
                      ><i class="material-icons-outlined">business_center</i
                      ><span>{{
                        this.$store.getters.getWordLocale("txt_firma_yonetimi")
                      }}</span></a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      :href="this.$store.state.messageCenterUrlX"
                      ><i class="material-icons-outlined">mail</i
                      ><span>{{
                        this.$store.getters.getWordLocale("txt_mesaj_merkezi")
                      }}</span></a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      :href="this.$store.state.requestCenterUrlX"
                      ><i class="material-icons-outlined">public</i
                      ><span>{{
                        this.$store.getters.getWordLocale("txt_talep_merkezi")
                      }}</span></a
                    >
                  </li>
                  <li>
                    <a v-on:click="logout" class="dropdown-item" href="#"
                      ><i class="material-icons-outlined">logout</i
                      ><span>{{
                        this.$store.getters.getWordLocale("txt_cikis_yap")
                      }}</span></a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import helper from "./helper";

export default {
  components: {},
  props: ["placeHolder"],
  data() {
    return {
      hostUrl: "",
      userPanelOpened: false,
      loggingOut: false,
      headerItemsToShow: [],
    };
  },
  methods: {
    reversePanelArrow() {
      this.userPanelOpened = !this.userPanelOpened;
    },
    async logout() {
      var result = [];
      var accessToken = helper.getCookie("fn_access_token");
      this.loggingOut = true;
      await fetch(`${this.$store.state.apiUrlX}/api/v2/Account/logout`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({}),
      })
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.loggingOut = false;
      if (result.resultText == "Success") {
        this.$store.state.userLoggedInX = false;
        helper.setCookie("fn_access_token", "");
        window.location.href = `http://auth.${this.$store.state.parentDomainX}/en/account/logout?returnUrl=${this.$store.state.currentUrlX}`;
      } else {
        this.$store.state.userLoggedInX = false;
        helper.setCookie("fn_access_token", "");
        window.location.href = `/${this.$store.state.langCodeX}`;
      }
    },
    searchEngine() {
      var host = window.location.href;
      this.$store.state.isSearchChangedX = true;
      if (host.indexOf("/lead/") !== -1) {
        this.$router.push(`/${this.$store.state.langCodeX}/leads`);
      } else if (
        host.indexOf("/companies") == -1 &&
        host.indexOf("/leads") == -1 &&
        host.indexOf("/products") == -1
      ) {
        if (
          this.$store.state.headerItemsX.filter(
            (q) => parseInt(q.id) == 1
          ).length > 0
        ) {
          this.$router.push(`/${this.$store.state.langCodeX}/companies`);
        } else if (
          this.$store.state.headerItemsX.filter(
            (q) => parseInt(q.id) == 2
          ).length > 0
        ) {
          this.$router.push(`/${this.$store.state.langCodeX}/leads`);
        } else {
          this.$router.push(`/${this.$store.state.langCodeX}/products`);
        }
      }
    },
    changeLanguage(langCode) {
      this.$store.state.langCodeX = langCode;
    },
  },
  mounted() {
    this.hostUrl = window.location.host
      .replace("http://", "")
      .replace("https://", "")
      .replace("/", "");

    this.$store.state.headerItemsX.forEach((element) => {
      var name =
        element.name == "Firma"
          ? "Firmalar"
          : element.name == "Talep"
          ? "Talepler"
          : "Ürünler";
      var link =
        element.name == "Firma"
          ? `/${this.$store.state.langCodeX}/companies`
          : element.name == "Talep"
          ? `/${this.$store.state.langCodeX}/leads`
          : `/${this.$store.state.langCodeX}/products`;

      this.headerItemsToShow.push({ name: name, link: link });
    });
  },
};
</script>

<style>
@import "./style.css";

.navbar-brand > img {
  max-width: 110px;
  max-height: 32px;
  width: 100%;
  height: auto;
}
.search {
  position: relative;
  display: flex;
  align-items: center;
}

.search input {
  height: 40px;
  min-width: 302px;
   padding-left: 40px;
  background: var(--m3--ref--primary--primary100);
  /* M3/read-only/light/outline/opacity-0.16 */
  border: 1px solid var(--m3--read-only--light--outline--opacity-016);
  box-sizing: border-box;
  border-radius: 100px;
}

.search input:focus {
  box-shadow: none;
}
.search input::placeholder {
  /* M3/body/medium */
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.25px;
  color: var(--m3--ref--neutral--neutral40);
}

.search .fa-search {
  position: absolute;
  left: 16px;
  color: var(--m3--sys--light--primary);
}
</style>